<template>
  <vue-env></vue-env>
  <vue-auth></vue-auth>
  <div class="app-shell app-shell-height flex flex-col">
    <div
      class="pointer-events-none absolute inset-0 bg-[radial-gradient(700px_circle_at_10%_-10%,rgba(225,43,52,0.25),transparent_55%),radial-gradient(800px_circle_at_90%_10%,rgba(59,130,246,0.15),transparent_60%)]">
    </div>
    <div class="relative mx-auto w-full max-w-[480px] flex-1">
      <div class="border border-white/10 bg-white/5 p-4 shadow-[0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur min-h-full">
        <router-view />
      </div>
    </div>
  </div>
  <FooterContent></FooterContent>
</template>

<script setup>
import { defineAsyncComponent } from "vue";
import VueEnv from "@/components/VueEnv.vue";
import VueAuth from "@/components/VueAuth.vue";

const FooterContent = defineAsyncComponent(() =>
  import("@/components/FooterContent.vue")
);

</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap");

body {
  margin: 0;
  font-family: "Space Grotesk", system-ui, -apple-system, sans-serif;
  background: #0b0f14;
  color: #e2e8f0;
}

.app-shell {
  background: #0b0f14;
  color: #e2e8f0;
}

body[data-theme="light"] {
  background: #f8fafc;
  color: #0f172a;
}

body[data-theme="light"] .app-shell {
  background: #f8fafc;
  color: #0f172a;
}

body[data-theme="light"] .app-shell .bg-white\/5 {
  background-color: rgba(15, 23, 42, 0.04) !important;
}

body[data-theme="light"] .app-shell .border-white\/10 {
  border-color: rgba(15, 23, 42, 0.12) !important;
}

body[data-theme="light"] .app-shell .bg-black\/20 {
  background-color: rgba(15, 23, 42, 0.06) !important;
}

body[data-theme="light"] .app-shell .bg-black\/30 {
  background-color: rgba(15, 23, 42, 0.08) !important;
}

body[data-theme="light"] .app-shell .text-slate-200,
body[data-theme="light"] .app-shell .text-slate-300 {
  color: #475569 !important;
}

body[data-theme="light"] .app-shell h4 {
  color: #0f172a !important;
}

body[data-theme="light"] .app-shell .text-slate-300,
body[data-theme="light"] .app-shell thead {
  color: #1f2937 !important;
}

body[data-theme="light"] .app-shell thead span {
  color: #1f2937 !important;
}

body[data-theme="light"] .app-shell .brand-title {
  color: #0f172a !important;
}

.app-shell-height {
  min-height: calc(100vh - 30px);
  height: calc(100vh - 30px);
}

body[data-theme="light"] .app-shell input,
body[data-theme="light"] .app-shell textarea {
  color: #0f172a !important;
}

body[data-theme="light"] .app-shell select {
  background-color: #ffffff !important;
  color: #0f172a !important;
}

body[data-theme="light"] .footer-text {
  color: #0f172a !important;
}
</style>
